export default __webpack_public_path__ + "static/media/SAMPLE.93ed1c9a.xlsx";